module.exports = __webpack_public_path__ + "static/media/lt_desk_r.7bde16ff.png";